import React, { useCallback, useEffect, useState } from 'react';
import styles from './Overview.module.less';
import classNames from 'classnames';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { imgLocalUrl } from '../../utils/utils';
import CommentOn from '../../components/CommentOn';

const selectForum = createSelector(
  state => state.forum,
  forum => forum,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

export default ({ specialInfo = {}, zan, handel, handelCommentOnData, scrollEl }) => {
  const [commentOn, setCommmentOn] = useState(false);
  const [commentOnClass, setCommmentOnClass] = useState(styles.overview_commenton_hidden);
  const [animationClass, setAnimationClass] = useState(styles.paused);
  const userInfo = useSelector(selectUserInfo);
  const handleNumber = (data = 0) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+data)) {
      return data;
    }
    if (+data < 1000) {
      return data > 0 ? data : 0;
    }
    if (+data < 10000) {
      return `${(data / 1000).toFixed(1)}k`;
    }

    return `${(data / 10000).toFixed(1)}w`;
  };

  const handleCommment = useCallback(type => {
    if (type) {
      setCommmentOn(type);
    } else {
      const showTimer = setTimeout(() => {
        setCommmentOn(type);
        clearTimeout(showTimer);
      }, 300);
    }

    if (type) {
      setCommmentOnClass(styles.overview_commenton_animation_show);
    } else {
      setCommmentOnClass(styles.overview_commenton_animation_hidden);
    }
    const timer = setTimeout(() => {
      setCommmentOnClass(type ? styles.overview_commenton_show : styles.overview_commenton_hidden);
      clearTimeout(timer);
    }, 300);
  }, []);
  return (
    <>
      {!commentOn && (
        <div className={styles.overview}>
          <div className={classNames(styles.overview_comment)}>
            <img
              src={
                userInfo.headimgurl
                  ? userInfo.headimgurl.indexOf('http') > -1
                    ? userInfo.headimgurl
                    : imgLocalUrl(userInfo.headimgurl)
                  : require('../../static/face.png')
              }
              className={styles.overview_comment_img}
            />
            <div
              className={styles.overview_comment_input}
              onClick={() => {
                handleCommment(true);
              }}
            >
              写下你的评论...
            </div>
          </div>
          <div
            className={classNames(styles.overview_item, specialInfo.hasCollect && styles.active)}
            onClick={handel.collect}
          >
            <i
              className={classNames(
                'iconfont',
                specialInfo.hasCollect ? 'icon-collected' : 'icon-shoucang',
              )}
            />
            <span>
              {specialInfo?.collectCount > 0 ? handleNumber(specialInfo.collectCount) : '收藏'}
            </span>
          </div>
          <div
            className={classNames(
              styles.overview_item,
              (specialInfo.hasZan || zan) && styles.active,
            )}
            onClick={handel.zan}
          >
            <i
              className={classNames(
                'iconfont',
                specialInfo.hasZan || zan ? 'icon-zan1' : 'icon-zan1',
              )}
            />
            <span>{specialInfo?.zanCount > 0 ? handleNumber(specialInfo.zanCount) : '赞'}</span>
          </div>
        </div>
      )}
      {
        <div className={`${styles.overview_commenton} ${commentOnClass} ${animationClass}`}>
          <div
            className={` iconfont icon-close ${styles.overview_commenton_close}`}
            onClick={() => {
              handleCommment(false);
            }}
          />
          {commentOnClass !== styles.overview_commenton_hidden && (
            <CommentOn
              requestInfo={{
                // tagCode:specialInfo?.tags&&specialInfo?.tags[0]?.tagId,
                type: '2',
                bizIdentity: `zt_${specialInfo?.ztId}`,
              }}
              hasScore={false}
              title="撰写评论"
              classWrapper="popComt"
              placeHolder="写下您的评论..."
              handleUpdate={data => {
                handelCommentOnData(data);
                handleCommment(false);
              }}
              commentTargetInfo={{
                targetId: specialInfo?.ztId,
                targetName: specialInfo?.ztTitle,
                targetCategoryCode: specialInfo?.tags?.map(item => item.tagId),
              }}
            />
          )}
        </div>
      }
      {commentOn && <div className={styles.modal} />}
    </>
  );
};
